import { UseGuardStepHook } from "@rapid/hooks/useGuardStep";
import { BuildSteps } from "@rapid/types/flows";
import { useGuardSetupStep } from "./useGuardSetupStep";

export const useGuardUpload: UseGuardStepHook = () => useGuardSetupStep(BuildSteps.UPLOAD);
